<template>
  <v-container fluid class="pa-6 user-assignment-page">
    <v-row dense>
      <!-- Paso 1: selector de manager -->
      <v-col cols="12" lg="4">
        <v-card outlined class="pa-4">
          <div class="text-subtitle-2 grey--text text--darken-1 mb-1">Paso 1</div>
          <div class="text-h6 font-weight-medium mb-3">Selecciona el usuario responsable</div>

          <s-user v-model="managerUser" :isCrud="false" :singleRow="true" @input="onManagerSelected" />

          <v-divider class="my-3" />

          <div v-if="managerUser.UsrID">
            <div class="text-caption grey--text text--darken-1 mb-1">Responsable activo</div>
            <v-chip color="primary" small label text-color="white">
              <v-icon left small>mdi-account</v-icon>
              {{ managerUser.UsrName }}
            </v-chip>
          </div>
          <div v-else class="text-body-2 grey--text">Selecciona un usuario para gestionar sus asignados.</div>
        </v-card>
      </v-col>

      <!-- Paso 2: tabla con checkboxes y auto-guardado -->
      <v-col cols="12" lg="8">
        <v-card outlined class="pa-4">
          <div class="d-flex justify-space-between align-center mb-3">
            <div>
              <div class="text-subtitle-2 grey--text text--darken-1">Paso 2</div>
              <div class="text-h6 font-weight-medium">Usuarios a cargo</div>
            </div>
            <div class="d-flex align-center">
              <v-progress-circular v-if="saving" indeterminate color="primary" size="18" width="2" class="mr-2" />
              <v-chip small :color="saving ? 'orange lighten-4' : 'success lighten-4'" :text-color="saving ? 'orange darken-3' : 'success darken-3'">
                {{ saving ? 'Guardando...' : selectedUsers.length + ' asignados' }}
              </v-chip>
            </div>
          </div>

          <v-alert v-if="!managerUser.UsrID" type="info" dense text border="left" class="mb-0">
            Selecciona primero un usuario responsable.
          </v-alert>

          <template v-if="managerUser.UsrID">
            <v-data-table
              v-model="selectedUsers"
              :headers="tableHeaders"
              :items="allUsers"
              :loading="loadingUsers"
              :search="searchText"
              show-select
              item-key="UsrID"
              dense
              :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
              @item-selected="onItemToggled"
              @toggle-select-all="onToggleAll"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchText"
                  label="Buscar usuario..."
                  prepend-inner-icon="mdi-magnify"
                  dense
                  outlined
                  hide-details
                  clearable
                  class="mb-3"
                />
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _userAssignmentService from "@/services/Security/UserAssignmentService";
import _sUserService from "@/services/Security/UserService";
import sUser from "./UserOption/User.vue";

export default {
  name: "UserAssignment",
  components: { sUser },
  data: () => ({
    managerUser: {},
    allUsers: [],
    selectedUsers: [],
    loadingUsers: false,
    saving: false,
    searchText: "",
    tableHeaders: [
      { text: "Usuario", value: "UsrName" },
      { text: "Persona", value: "NtpFullName" },
    ],
  }),
  mounted() {
    this.loadAllUsers();
  },
  methods: {
    extractSingleUser(payload) {
      if (!payload) return null;
      if (payload.UsrID) return payload;
      if (Array.isArray(payload)) return payload.find((i) => i && i.UsrID) || null;
      if (typeof payload === "object") {
        return Object.values(payload).find((i) => i && i.UsrID) || null;
      }
      return null;
    },
    onManagerSelected(raw) {
      const user = this.extractSingleUser(raw);
      this.managerUser = user || {};
      this.selectedUsers = [];
      if (user && user.UsrID) this.loadAssignments(user.UsrID);
    },
    loadAllUsers() {
      this.loadingUsers = true;
      _sUserService
        .pagination(
          { draw: 1, start: 0, length: 9999, searchText: "", filter: { UsrStatus: 1, SecStatus: 1 } },
          this.$fun.getUserID()
        )
        .then((r) => {
          this.allUsers = r && r.data && r.data.data ? r.data.data : [];
        })
        .finally(() => {
          this.loadingUsers = false;
        });
    },
    loadAssignments(managerUsrID) {
      this.loadingUsers = true;
      _userAssignmentService
        .list(managerUsrID, this.$fun.getUserID())
        .then((r) => {
          const assigned = r && r.data ? r.data : [];
          const assignedIDs = new Set(
            assigned.map((u) => u.UsrID || u.AssignedUsrID || 0).filter((id) => id > 0)
          );
          this.selectedUsers = this.allUsers.filter((u) => assignedIDs.has(u.UsrID));
        })
        .finally(() => {
          this.loadingUsers = false;
        });
    },
    onItemToggled() {
      this.$nextTick(() => this.autoSave());
    },
    onToggleAll() {
      this.$nextTick(() => this.autoSave());
    },
    autoSave() {
      if (!this.managerUser || !this.managerUser.UsrID) return;
      this.saving = true;
      _userAssignmentService
        .save(
          {
            ManagerUsrID: this.managerUser.UsrID,
            AssignedUsrIDs: this.selectedUsers.map((u) => u.UsrID),
          },
          this.$fun.getUserID()
        )
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.user-assignment-page {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef3fb 100%);
  min-height: 100%;
}

.assignment-hero {
  background: linear-gradient(135deg, #15314b 0%, #246b8f 100%);
}

.assignment-subtitle {
  color: rgba(255, 255, 255, 0.85);
  max-width: 720px;
}

.assignment-summary {
  background: #f7f9fc;
  border: 1px solid #e4ebf5;
}
</style>